import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PieChart } from 'vue-chart-3'
import { Chart, registerables } from 'chart.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppPieChart',
  props: ['options', 'chartData'],
  setup(__props) {

const props = __props;

Chart.register(...registerables)

// eslint-disable-next-line vue/require-prop-types


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PieChart), {
    "chart-data": props.chartData,
    options: props.options
  }, null, 8, ["chart-data", "options"]))
}
}

})